import React, { FC, PropsWithChildren, createContext, useMemo } from "react";

import useConfig from "@providers/configProvider/useConfig";

import useUserState from "./useUserState";

const UserContext = createContext<any | undefined>(undefined);

const UserProvider: FC<PropsWithChildren> = ({ children }) => {
  const { config } = useConfig();

  const {
    isLoading,
    isLoadingImages,
    getUser,
    user,
    activeBarcode,
    activePhoneNumber,
    saveUser,
    saveGuestWithVisit,
    refetchUserData,
    resetUser,
    photos,
    share,
    saveSiverScreenBg,
    selectedPhotos,
    selectPhoto,
    selectSinglePhoto,
    selectAllPhotos,
    clearSelectedPhotos,
    markPhotoAsUsed,
    saveAdjustments,
    downloadMedia,
    submitVisitForm,
    triggerAnimation,
    refetchPhotos,
  } = useUserState(config?.providedBarcode, config?.providedPhoneNumber);

  const value = useMemo(
    () => ({
      isLoading,
      isLoadingImages,
      getUser,
      user,
      saveUser,
      saveGuestWithVisit,
      refetchUserData,
      resetUser,
      photos,
      share,
      saveSiverScreenBg,
      activeBarcode,
      activePhoneNumber,
      selectedPhotos,
      selectPhoto,
      selectSinglePhoto,
      selectAllPhotos,
      clearSelectedPhotos,
      markPhotoAsUsed,
      saveAdjustments,
      downloadMedia,
      submitVisitForm,
      triggerAnimation,
      refetchPhotos,
    }),
    [
      isLoading,
      isLoadingImages,
      user,
      activeBarcode,
      activePhoneNumber,
      photos,
      selectedPhotos,
      saveGuestWithVisit,
      submitVisitForm,
      triggerAnimation,
      refetchPhotos,
    ]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export { UserProvider, UserContext };
